import { useRef } from 'react';
import { X } from 'lucide-react';

import { Button } from './Button';
import styles from './FilePicker.module.css';

export interface FilePickerProps {
  file: File | null;
  onPick: (file: File | null) => void;
  accept?: string;
  disabled?: boolean;
  buttonLabel?: string;
  emptyLabel?: string;
  ariaLabel?: string;
  className?: string;
}

export function FilePicker({
  file,
  onPick,
  accept,
  disabled = false,
  buttonLabel = 'Выбрать файл',
  emptyLabel = 'файл не выбран',
  ariaLabel,
  className,
}: FilePickerProps) {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <div className={[styles.row, className].filter(Boolean).join(' ')}>
      <input
        ref={ref}
        type="file"
        accept={accept}
        className={styles.hidden}
        aria-label={ariaLabel ?? buttonLabel}
        disabled={disabled}
        onChange={(event) => {
          onPick(event.target.files?.[0] ?? null);
          event.target.value = '';
        }}
      />
      <Button size="sm" disabled={disabled} onClick={() => ref.current?.click()}>
        {buttonLabel}
      </Button>
      {(file || emptyLabel) && (
        <span className={file ? styles.name : styles.empty} title={file?.name}>
          {file ? file.name : emptyLabel}
        </span>
      )}
      {file && (
        <Button
          size="sm"
          iconOnly
          variant="ghost"
          disabled={disabled}
          onClick={() => onPick(null)}
          aria-label="Убрать файл"
          title="Убрать файл"
        >
          <X size={13} strokeWidth={1.6} />
        </Button>
      )}
    </div>
  );
}
